import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PaymentPreferences {
  paymentType: 'Finance' | 'Lease';
  term: number | null;
  kmAllowance: number | null;
}

interface PaymentPreferencesContextType {
  preferences: PaymentPreferences;
  updatePreferences: (updates: Partial<PaymentPreferences>) => void;
}

const PaymentPreferencesContext = createContext<PaymentPreferencesContextType | undefined>(undefined);

export const PaymentPreferencesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [preferences, setPreferences] = useState<PaymentPreferences>({
    paymentType: 'Lease',
    term: null,
    kmAllowance: null
  });

  const updatePreferences = (updates: Partial<PaymentPreferences>) => {
    setPreferences(prev => ({ ...prev, ...updates }));
  };

  return (
    <PaymentPreferencesContext.Provider value={{ preferences, updatePreferences }}>
      {children}
    </PaymentPreferencesContext.Provider>
  );
};

export const usePaymentPreferences = () => {
  const context = useContext(PaymentPreferencesContext);
  if (!context) {
    throw new Error('usePaymentPreferences must be used within PaymentPreferencesProvider');
  }
  return context;
};
